<template>
  <div class="wrapper">
    <div class="d-flex align-items-center m-1 p-2">
      <RuleMinMaxCountCondition
        :rule-reference="ruleReference"
        :title="trans(`subscription.validation_rules.rules.${rule.type}.minimal`)"
        :rule-property="rulePropertyConstant.min"
        :current-count="rule.min"
      />
      <RuleMinMaxCountCondition
        :rule-reference="ruleReference"
        :title="trans(`subscription.validation_rules.rules.${rule.type}.maximum`)"
        :rule-property="rulePropertyConstant.max"
        :current-count="rule.max"
      />
    </div>
    <template v-for="(value, index) in rule.values">
      <RuleAggregateValue
        :key="index"
        :aggregate-value="value"
        :parent-reference="ruleReference"
      />
    </template>
    <RuleAdd
      :rule-reference="ruleReference"
      :rule-type="ruleType.aggregate"
    />
  </div>
</template>

<script>
import { RULE_PROPERTY, RULE_TYPE } from '@/constants'
export default {
  name: 'RuleAggregate',
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
    rule: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      rulePropertyConstant: RULE_PROPERTY,
      ruleType: RULE_TYPE,
    }
  },
}
</script>
